import React, { Component } from 'react';
import { masterService } from '../../../_services';
import { NavLink } from 'react-router-dom';
import Pagination from "react-js-pagination";

import MasterMenu from "./master-menu";
import $ from 'jquery';
import { toast } from 'react-toastify';
import { alertConstants } from '../../../_constants'

class MasterPermissionType extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
        this.state = {
            activePage: 1,
            itemPerPage: 10,
            listPermissionTypes: [],
            addFields: {
                permissionTypeName: ''
            },
            addErrors: {
                permissionTypeName: ''
            },
            editFields: {
                permissionTypeName: '',
                id: ''
            },
            editErrors: {
                permissionTypeName: ''
            }
        };
        this.handlePageChange = this.handlePageChange.bind(this)
        this.handleItemChange = this.handleItemChange.bind(this)
    }
    loading = false;
    handleUpdateValidation() {
        let editFields = this.state.editFields;
        let editErrors = {};
        let formIsValid = true;
        if (editFields["permissionTypeName"] === '') {
            formIsValid = false;
            editErrors["permissionTypeName"] = "Permission Type is required";
        } else if (typeof editFields["permissionTypeName"] !== "undefined") {
            if (!editFields["permissionTypeName"].match(/^[a-zA-Z]+$/)) {
                formIsValid = false;
                editErrors["permissionTypeName"] = "Only letters allowed";
            }
        }
        this.setState({ editErrors: editErrors });
        return formIsValid;
    }

    handleEditChange(field, e) {
        let editFields = this.state.editFields;
        editFields[field] = e.target.value;
        this.setState({ editFields });
        this.setState({ editErrors: '' })
    }

    handleAddValidation() {
        let addFields = this.state.addFields;
        let addErrors = {};
        let formIsValid = true;
        if (addFields["permissionTypeName"] === '') {
            formIsValid = false;
            addErrors["permissionTypeName"] = "Permission Type is required";
        } else if (typeof addFields["permissionTypeName"] !== "undefined") {
            if (!addFields["permissionTypeName"].match(/^[a-zA-Z]+$/)) {
                formIsValid = false;
                addErrors["permissionTypeName"] = "Only letters allowed";
            }
        }
        this.setState({ addErrors: addErrors });
        return formIsValid;
    }

    addSubmit(e) {
        e.preventDefault();
        if (this.handleAddValidation()) {
            this.loading = true;
            masterService.addPermissionType(this.state.addFields)
                .then(
                    data => {
                        if (!toast.isActive(this.toastId)) {
                            this.toastId = toast.success(alertConstants.CREATED_SUCCESSFULLY)
                        }
                        this.getPermissionType()
                        $('.close').click();
                    }, error => {
                        this.loading = false;
                        if (error.statusCode === 422) {
                            let errors = error.message
                            Object.keys(errors).map(key => {
                                return (
                                    toast.error(errors[key])
                                );
                            })
                        } else {
                            toast.error(error.message)
                        }
                    }
                ).finally(() => { this.loading = false; this.forceUpdate() });
        }
    }

    editSubmit(e) {
        e.preventDefault();
        if (this.handleUpdateValidation()) {
            this.loading = true;
            masterService.editPermissionType(this.state.editFields)
                .then(
                    data => {
                        if (!toast.isActive(this.toastId)) {
                            this.toastId = toast.success(alertConstants.UPDATED_SUCCESSFULLY)
                        }
                        this.getPermissionType()
                        $('.close').click();
                    }, error => {
                        this.loading = false;
                        if (error.statusCode === 422) {
                            let errors = error.message
                            Object.keys(errors).map(key => {
                                return (
                                    toast.error(errors[key])
                                );
                            })
                        } else {
                            toast.error(error.message)
                        }
                    }
                ).finally(() => { this.loading = false; this.forceUpdate() });
        }
    }

    cancelAdd() {
        // this.setState({addErrors:'',addFields:''})
        // document.getElementById("create-form").();
        $('#create-form input').val('')
    }

    handleChange(field, e) {
        let addFields = this.state.addFields;
        addFields[field] = e.target.value;
        this.setState({ addFields });
        this.setState({ addErrors: '' })
    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber }, () =>
            this.getPermissionType());
    }
    handleItemChange(limit) {
        this.setState({ itemPerPage: limit, activePage: 1 }, () =>
            this.getPermissionType());
    }

    componentDidMount() {
        this.getPermissionType()
    }
    loader = false;
    count = 0;
    getPermissionType() {
        this.setState({ listPermissionTypes: [] })
        this.loader = true;
        masterService.getPermissionTypeByPage(this.state.activePage, this.state.itemPerPage)
            .then(
                data => {
                    if (data != null) {
                        this.count = data.count
                        this.setState({ listPermissionTypes: data.result })
                    }
                }
            ).finally(() => { this.loader = false; this.forceUpdate() });

    }

    changeStatus(id, status) {
        masterService.activeInactivePermissionTypes(id, { activeStatus: status })
            .then(
                data => {
                    if (!toast.isActive(this.toastId)) {
                        this.toastId = toast.success(data.message)
                    }
                    this.getPermissionType()
                }, error => {
                    this.loading = false;
                    if (error.statusCode === 422) {
                        let errors = error.message
                        Object.keys(errors).map(key => {
                            return (
                                toast.error(errors[key])
                            );
                        })
                    } else {
                        toast.error(error.message)
                    }
                }
            ).finally(() => { this.loading = false; this.forceUpdate() });
    }

    doSearch(queryText) {
        //get query result
        var queryResult = [];
        this.props.data.forEach(function (person) {
            if (person.name.toLowerCase().indexOf(queryText) !== -1)
                queryResult.push(person);
        });

        this.setState({
            query: queryText,
            filteredData: queryResult
        })
    }

    editData(data) {
        let editFields = this.state.editFields;
        editFields['permissionTypeName'] = data.permissionTypeName;
        editFields['id'] = data.id;
        this.setState({ editFields });
        this.setState({ editErrors: '' })
    }

    render() {
        const { listPermissionTypes, itemPerPage } = this.state;
        return (

            <div className="master">
                <MasterMenu />
                <div className="inner-wrapper">
                    <NavLink to="" data-toggle="modal" data-target="#CreatUserModal"
                        className="add-button text-white">+</NavLink>
                    <div className="inner-header">
                        <div className="shape-header">
                            <div className="left">M</div>
                            <div className="right">
                                <h6 className="heading">Manage PermissionTypes</h6>
                                <p className="text">Lorem Ipsum is simply dummy</p>
                            </div>
                        </div>
                    </div>
                    <div className="py-padding">
                        <div className="table-container">
                            <form autoComplete="off">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="dropdown">
                                            <button type="button" className="btn dropdown-toggle"
                                                data-toggle="dropdown">
                                                Action
                                            </button>
                                            <div className="dropdown-menu">
                                                <button className="dropdown-item">Make Inactive</button>
                                                <button className="dropdown-item">Delete</button>
                                                <button className="dropdown-item">Edit</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2 offset-md-8">
                                        <div className="search-custom">
                                            <input type="text" name="" className="form-control" placeholder="Search" />
                                            <span><i className="material-icons">search</i></span>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Permission Type</th>
                                            <th>Action</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.loader === true &&
                                            <tr>
                                                <td colSpan="3">Loading</td>
                                            </tr>
                                        }
                                        {!listPermissionTypes && this.loader === false &&
                                            <tr>
                                                <td colSpan="3" className="text-center">No Records Found</td>
                                            </tr>}
                                        {listPermissionTypes &&
                                            listPermissionTypes.map((item, key) => {
                                                return (
                                                    <tr key={key}>
                                                        <td>{item.permissionTypeName}</td>
                                                        <td>
                                                            <button data-toggle="modal" onClick={e => this.editData(item)}
                                                                data-target="#EditUserModal"
                                                                className="btn btn-border-primary btn-sm sm-padding">Edit
                                                    </button>
                                                        </td>
                                                        <td>
                                                            {(item.activeStatus === true) ?
                                                                <div>
                                                                    <label className="switch">
                                                                        <input type="checkbox"
                                                                            onChange={e => this.changeStatus(item.id, "false")}
                                                                            defaultChecked={item.activeStatus === true} />
                                                                        <span className="slider round"></span>
                                                                    </label>
                                                                    <span>Active</span>
                                                                </div> :
                                                                <div>
                                                                    <label className="switch">
                                                                        <input type="checkbox"
                                                                            onChange={e => this.changeStatus(item.id, "true")} />
                                                                        <span className="slider round"></span>
                                                                    </label>
                                                                    <span>Inactive</span>
                                                                </div>
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="table-footer">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="page-count">
                                            <div className="text">Items</div>
                                            <div className="dropdown">
                                                <button type="button" className="btn dropdown-toggle"
                                                    data-toggle="dropdown">
                                                    {itemPerPage}
                                                </button>
                                                <div className="dropdown-menu">
                                                    <button onClick={e => this.handleItemChange(10)} className="dropdown-item">10</button>
                                                    <button onClick={e => this.handleItemChange(20)} className="dropdown-item">20</button>
                                                    <button onClick={e => this.handleItemChange(30)} className="dropdown-item">30</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-9">
                                        {listPermissionTypes &&
                                            <Pagination
                                                activePage={this.state.activePage}
                                                itemsCountPerPage={this.state.itemPerPage}
                                                totalItemsCount={this.count}
                                                pageRangeDisplayed={3}
                                                onChange={this.handlePageChange}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="CreatUserModal" tabIndex="-1" role="dialog"
                    aria-labelledby="CreateUserModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <form autoComplete="off" id="create-form" onSubmit={this.addSubmit.bind(this)}>
                                <div className="modal-header">
                                    <h5 className="modal-title" id="CreateUserModalLabel">Create Permission Type</h5>
                                    <button type="button" onClick={e => this.cancelAdd(e)} className="close"
                                        data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div
                                        className={(this.state.addErrors["permissionTypeName"]) ? 'has-error form-group' : 'form-group'}>
                                        <input className="form-control"
                                            type="text"
                                            name="permissionTypeName"
                                            onChange={this.handleChange.bind(this, "permissionTypeName")}
                                            value={this.state.addFields["permissionTypeName"]}
                                            placeholder="Name" />
                                        <div className="help-block">{this.state.addErrors["permissionTypeName"]}</div>
                                    </div>
                                </div>
                                {(this.loading === false) ?
                                    <div className="modal-footer">
                                        <button type="submit" className="btn btn-border-success lg-padding">Save</button>
                                        <button type="button" onClick={this.cancelAdd()}
                                            className="btn btn-border-basic lg-padding" data-dismiss="modal">Cancel
                                        </button>
                                    </div> :
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-border-success lg-padding">Please Wait...</button>
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="EditUserModal" tabIndex="-1" role="dialog"
                    aria-labelledby="EditUserModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <form autoComplete="off" id="edit-form" onSubmit={this.editSubmit.bind(this)}>
                                <div className="modal-header">
                                    <h5 className="modal-title" id="EditUserModalLabel">Edit Permission Type</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div
                                        className={(this.state.editErrors["permissionTypeName"]) ? 'has-error form-group' : 'form-group'}>
                                        <input className="form-control"
                                            type="text"
                                            name="permissionTypeName"
                                            onChange={this.handleEditChange.bind(this, "permissionTypeName")}
                                            value={this.state.editFields["permissionTypeName"]}
                                            placeholder="Name" />
                                        <div className="help-block">{this.state.editErrors["permissionTypeName"]}</div>
                                    </div>
                                </div>
                                {(this.loading === false) ?
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-border-success lg-padding">Save</button>
                                        <button type="button" onClick={this.cancelAdd()}
                                            className="btn btn-border-basic lg-padding" data-dismiss="modal">Cancel
                                        </button>
                                    </div> :
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-border-success lg-padding">Please Wait...</button>
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default MasterPermissionType 